import { render, staticRenderFns } from "./SeasonRivalryChip.vue?vue&type=template&id=074d8228&scoped=true&"
import script from "./SeasonRivalryChip.vue?vue&type=script&lang=js&"
export * from "./SeasonRivalryChip.vue?vue&type=script&lang=js&"
import style0 from "./SeasonRivalryChip.vue?vue&type=style&index=0&id=074d8228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074d8228",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VIcon,VTooltip})
